module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "part1"
    }
  }), _vm._v("THE STORIES")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Stalking the flats around Jardines de la Reina, where tarpon, bone-fish, permit—and crocodiles—make for excellent sport.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02826ec8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 87
// module chunks = 0